import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Tab, { TabPresentationProps } from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React from "react";
import styled, { css } from "styled-components";

const enum fields {
    sectionOne = "sectionOne",
    sectionTwo = "sectionTwo",
    sectionThree = "sectionThree",
    sectionFour = "sectionFour",
    sectionFive = "sectionFive",
}

interface cssOverrides {
    tabGroup?: InjectableCss;
    tabContent?: InjectableCss;
    wrapper?: InjectableCss;
}

interface Props extends WidgetProps {
    fields: {
        [fields.sectionOne]: string;
        [fields.sectionTwo]: string;
        [fields.sectionThree]: string;
        [fields.sectionFour]: string;
        [fields.sectionFive]: string;
    };
    selected?: boolean;
}

/* const CustomTabComponent: React.FC<Props> = ({ fields, id }, props) => { */
const CustomTabComponent: React.FC<Props> = props => {
    const { fields, id, selected } = props;
    const { sectionOne, sectionTwo, sectionThree, sectionFour, sectionFive } = fields;

    const cssOverrides: cssOverrides = {
        wrapper: {
            css: css`
                border: ${props.selected ? "none" : "1.5px solid #046faf"};
                background: ${props.selected ? "#046faf" : "white"};
                padding: 0.5rem;
                color: ${props.selected ? "white" : "#046faf"};
                display: flex;
                align-items: center;
                flex-basis: 19.5%;
                &:hover {
                    cursor: pointer;
                    border-bottom: 1.5px solid #046faf;
                }
                &:focus {
                    color: white;
                    background: #046faf;
                }
                &:active {
                    color: white;
                    background: #046faf;
                }
            `,
        },
        tabContent: {
            css: css`
                border: 2px solid #046faf;
            `,
        },
        tabGroup: {
            css: css`
                justify-content: space-between;
                margin-bottom: 3px;
                padding: unset;
            `,
        },
    };

    return (
        <StyledWrapper>
            <TabGroup>
                <Tab css={cssOverrides?.wrapper?.css} headline={parse(sectionOne, parserOptions)} tabKey="section 1">
                    <Zone contentId={id} zoneName="Content" />
                </Tab>
                <Tab css={cssOverrides?.wrapper?.css} headline={parse(sectionTwo, parserOptions)} tabKey="section 2">
                    <Zone contentId={id + 1} zoneName="Content" />
                </Tab>
                <Tab css={cssOverrides?.wrapper?.css} headline={parse(sectionThree, parserOptions)} tabKey="section 3">
                    <Zone contentId={id + 2} zoneName="Content" />
                </Tab>
                <Tab css={cssOverrides?.wrapper?.css} headline={parse(sectionFour, parserOptions)} tabKey="section 4">
                    <Zone contentId={id + 3} zoneName="Content" />
                </Tab>
                <Tab css={cssOverrides?.wrapper?.css} headline={parse(sectionFive, parserOptions)} tabKey="section 5">
                    <Zone contentId={id + 3} zoneName="Content" />
                </Tab>
            </TabGroup>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomTabComponent,
    definition: {
        fieldDefinitions: [
            {
                name: fields.sectionOne,
                displayName: "Tab one title",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Tab One",
            },
            {
                name: fields.sectionTwo,
                displayName: "Tab two title",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Tab Two",
            },
            {
                name: fields.sectionThree,
                displayName: "Tab three title",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Tab Three",
            },
            {
                name: fields.sectionFour,
                displayName: "Tab four title",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Tab Four",
            },
            {
                name: fields.sectionFive,
                displayName: "Tab five title",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Tab Five",
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
